import { render, staticRenderFns } from "./PersonRow.vue?vue&type=template&id=21fc514a&"
import script from "./PersonRow.vue?vue&type=script&lang=js&"
export * from "./PersonRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports